import { Action, ThunkAction } from "@reduxjs/toolkit";
import { requestApi } from "./common";
import { RootState } from "../store";
import { notificationActions } from "../slices/notification";
import objectToQueryParam from "../../utils/objectToQueryParam";
import { userActions } from "../slices/user";
import { cmsActions } from "../slices/cms";
import { fireEvent } from "../slices/levent";

type ThunkResult<R> = ThunkAction<R, RootState, undefined, Action<string>>;

export const fetchData = (
  context: string,
  path: string,
  reqData: any,
  cmsAction: string,
  nestedCmsKey?: string,
  loading: boolean = true
): ThunkResult<void> => {
  return async (dispatch) => {
    if (loading) dispatch(notificationActions.toggleLoading(true));
    const QUERY_PARAMS = objectToQueryParam(reqData);

    const res = await requestApi<any>(
      `${process.env.REACT_APP_API_BASE_URL}${context}${path}${QUERY_PARAMS}`,
      "GET"
    );

    if (res.error) {
      dispatch(
        notificationActions.toggleNotification({
          title: "Error",
          description: res.error,
          type: "error",
        })
      );
    }

    if (res.data) {
      if (nestedCmsKey) {
        dispatch(
          cmsActions.setNestedCms({
            type: cmsAction,
            nestedKey: nestedCmsKey,
            data: res.data,
          })
        );
      } else if (cmsAction) {
        dispatch(
          cmsActions.setCms({
            type: cmsAction,
            data: res.data,
          })
        );
      } else return res.data;
    }
    if (loading) dispatch(notificationActions.toggleLoading(false));
  };
};

export const fetchDataById = (
  context: string,
  path: string,
  id: string,
  reqData: any,
  cmsAction?: string,
  loading: boolean = true
): ThunkResult<void> => {
  return async (dispatch) => {
    if (loading) dispatch(notificationActions.toggleLoading(true));
    const QUERY_PARAMS = objectToQueryParam(reqData);

    const res = await requestApi<any>(
      `${process.env.REACT_APP_API_BASE_URL}${context}${path}${id}${QUERY_PARAMS}`,
      "GET"
    );

    if (res.error) {
      dispatch(
        notificationActions.toggleNotification({
          title: "Error",
          description: res.error,
          type: "error",
        })
      );
    }

    if (res.data) {
      if (loading) dispatch(notificationActions.toggleLoading(false));

      if (cmsAction)
        dispatch(
          cmsActions.setCms({
            type: cmsAction,
            data: res.data,
          })
        );
      else return res.data;
    }

    if (loading) dispatch(notificationActions.toggleLoading(false));
  };
};

export const postData = (
  context: string,
  path: string,
  reqData: any,
  refreshKey?: string,
  navigateFunction?: any,
  loading: boolean = true,
  cmsAction?: string
): ThunkResult<void> => {
  return async (dispatch) => {
    if (loading) dispatch(notificationActions.toggleLoading(true));

    const res = await requestApi<any>(
      `${process.env.REACT_APP_API_BASE_URL}${context}${path}`,
      "POST",
      reqData
    );

    if (res.error) {
      dispatch(
        notificationActions.toggleNotification({
          title: "Error",
          description: res.error,
          type: "error",
        })
      );
    }

    if (res.data) {
      if (!cmsAction)
        dispatch(
          notificationActions.toggleNotification({
            title: "Success",
            description: `${refreshKey} created`,
            type: "success",
          })
        );
      if (cmsAction)
        dispatch(
          cmsActions.setCms({
            type: cmsAction,
            data: res.data,
          })
        );
      else if (navigateFunction) {
        navigateFunction(res.data);
      } else if (refreshKey) {
        dispatch(fireEvent({ event: refreshKey }));
      } else {
        return res.data;
      }
    }

    if (loading) dispatch(notificationActions.toggleLoading(false));
  };
};

export const putData = (
  context: string,
  path: string,
  uniId: string,
  reqData: any,
  refreshKey: string
): ThunkResult<void> => {
  return async (dispatch) => {
    dispatch(notificationActions.toggleLoading(true));

    const res = await requestApi<any>(
      `${process.env.REACT_APP_API_BASE_URL}${context}${path}${uniId}`,
      "PUT",
      reqData
    );

    if (res.error) {
      dispatch(
        notificationActions.toggleNotification({
          title: "Error",
          description: res.error,
          type: "error",
        })
      );
    }

    if (res.data) {
      dispatch(
        notificationActions.toggleNotification({
          title: "Success",
          description: `${refreshKey} edited`,
          type: "success",
        })
      );
      if (refreshKey) dispatch(fireEvent({ event: refreshKey }));
    }

    dispatch(notificationActions.toggleLoading(false));
  };
};

export const deleteData = (
  context: string,
  path: string,
  uniId: any,
  refreshKey: string
): ThunkResult<void> => {
  return async (dispatch) => {
    dispatch(notificationActions.toggleLoading(true));

    const res = await requestApi<any>(
      `${process.env.REACT_APP_API_BASE_URL}${context}${path}${uniId}`,
      "DELETE"
    );

    if (res.error) {
      dispatch(
        notificationActions.toggleNotification({
          title: "Error",
          description: res.error,
          type: "error",
        })
      );
    }

    if (res.data) {
      // dispatch(
      //   cmsActions.setCms({
      //     type: cmsAction,
      //     data: res.data,
      //   })
      // );
      dispatch(
        notificationActions.toggleNotification({
          title: "Success",
          description: `${refreshKey} deleted`,
          type: "success",
        })
      );
      if (refreshKey) dispatch(fireEvent({ event: refreshKey }));
    }

    dispatch(notificationActions.toggleLoading(false));
  };
};
